export default __webpack_public_path__ + "v1.18.25/static/media/libreView-small.22d31a32.svg";